import Vue from 'vue';

export default {
    capitalizeFirstLetter: (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    flattenCategories:  (categories, fl = []) =>{
    	return _.transform(categories, (result, cat) => {
    		result.push({
    			id : cat.id,
    			name : cat.title,
    		});
    		result = _.concat(result, Vue.helpers.flattenCategories(cat.categories, result));
    	}, fl)
    },

    extendCategories: (categories, fl = []) => {
        return _.transform(categories, (result, cat) =>{
            result.push(cat);
            result = _.concat(result, Vue.helpers.extendCategories(cat.categories, result));
        }, fl)
    },
    flatCategoryWithParents: (category, result = []) => {
        result.push(category);
        let parrparents = Vue.helpers.flatCategoryParents(category);
        if ( parrparents.length > 0 ) result = _.concat(result, parrparents);
        return result;
    },
    flatCategoryParents: (category, result = []) => {
        if ( category.parent === null ) return [];
        result.push(category.parent);
        let subparents = Vue.helpers.flatCategoryParents(category.parent);
        if ( subparents.length > 0 ) result = _.concat(result, subparents);

        return result;
    }
}